// src/utils/request.ts
import { loginOut } from '@/components/RightContent/AvatarDropdown';
import { request } from '@umijs/max';
import { message } from 'antd';
import { getSessionCookie } from './cookie';

const wrapperRequest = async <T>(url: string, options: any = {}): Promise<T> => {
  try {
    const sessionId = getSessionCookie();
    const res = await request<T>(url, {
      baseURL: BASE_URL,
      credentials: 'include',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        Authorization: sessionId,
        ...(options.headers || {}),
      },
    });
    return res as T;
  } catch (error: any) {
    if (!error.response) {
      console.error('Network error', error);
      throw error;
    }
    const { status } = error.response;
    if (status === 401) {
      message.error('Phiên đăng nhập đã hết hạn');
      loginOut();
    }
    throw error;
  }
};

export default wrapperRequest;
